<template>
  <div>
    <!-- Status and Campaign -->
    <div class="columns">
      <div class="column is-6">
        <form-field-select-status
          label="Status"
          v-model="form.status_id"
          :validation-errors="validationErrors.status_id"
          include-no-status
        ></form-field-select-status>

        <form-field-select
          label="Campaign"
          v-model="form.campaign_id"
          :validation-errors="validationErrors.campaign_id"
        >
          <option
            v-for="campaign in allCampaigns"
            :key="campaign.id"
            :value="campaign.id"
          >{{ campaign.label }}</option>
        </form-field-select>
      </div>

      <div class="column is-6">
        <!-- Required Due At Date -->
        <form-field-datetime-picker
          v-if="statusRequiresDueAt"
          label="Status Change Date"
          v-model="form.due_at"
          help-text="This status requires you to set a status change date."
          :validation-errors="validationErrors.due_at"
        ></form-field-datetime-picker>

        <!-- Required Next Contact Date -->
        <form-field-datetime-picker
          v-if="statusRequiresNextContactAt"
          label="Next Contact At"
          v-model="form.next_contact_at"
          help-text="This status requires you to set a next contact at date."
          :validation-errors="validationErrors.next_contact_at"
        ></form-field-datetime-picker>
      </div>
    </div>

    <hr>

    <h4 class="text-uppercase mb-4">Property</h4>

    <form-field-address
      :entity="form.property"
      include-county
      :validation-errors="validationErrors"
    ></form-field-address>

    <hr>

    <template v-if="! propContact">
      <h4 class="text-uppercase mb-4">Primary Contact</h4>

      <form-field-full-name
        :entity="form.contact"
        :validation-errors="validationErrors"
      ></form-field-full-name>

      <form-field-phone
        label="Phone"
        v-model="form.contact.phone_1"
        :validation-errors="validationErrors.contact ? validationErrors.contact.phone_1 : validationErrors.contact"
      ></form-field-phone>

      <form-field-input
        label="Email"
        type="email"
        v-model="form.contact.email_address"
        :validation-errors="validationErrors.contact ? validationErrors.contact.email_address : validationErrors.contact"
      ></form-field-input>

      <hr>
    </template>

    <h4 class="text-uppercase mb-4">Users</h4>

<!--    <form-field grouped group-multiline>-->
<!--      <b-checkbox-button-->
<!--        v-for="user in activeUsers"-->
<!--        :key="user.id"-->
<!--        v-model="form.user_ids"-->
<!--        :native-value="user.id"-->
<!--        size="is-small"-->
<!--        :disabled="!authUser.can_access_all_leads && authUser.id === user.id"-->
<!--      >{{ user.full_name }}</b-checkbox-button>-->
<!--    </form-field>-->

    <form-field-select-record-users
      v-bind:user-ids="form.user_ids"
      v-on:user-ids-changed="form.user_ids = $event"

      v-bind:roles="form.roles"
      v-on:roles-changed="form.roles = $event"
    ></form-field-select-record-users>

    <p
      v-if="!authUser.can_access_all_leads"
      class="is-italic is-size-7"
    >You will always be assigned to the leads you create.</p>
  </div>
</template>

<script>
  import {FormMixin} from "./forms.mixin";
  import {appendModal, prependModal} from "../services/modals";
  import {ENUMS} from "../services/enums";
  import dates from "../services/dates";
  import DuplicateWarningModal from "../modules/duplicates/DuplicateWarningModal.vue";
  import Console from "../services/console";
  import SetUsers from "../modules/lead/components/SetUsers.vue";
  import FormFieldSelectRecordUsers from "../components/form/FormFieldSelectRecordUsers.vue";
  import router from "../router";

  export default {
    name: "RecordForm",
    components: {FormFieldSelectRecordUsers, SetUsers},
    props: {
      formData: {
        type: Object
      },
      propContact: {
        type: Object,
        required: false
      }
    },
    mixins: [FormMixin],
    data() {
      return {
        validationErrors: {},
        form: {
          validate_duplicates: true,
          market_id: this.$store.getters.market.id,
          status_id: null, // this.$store.getters['pipeline/activeStatuses'][0].id,
          due_at: dates.getTomorrowISO(),
          next_contact_at: null,
          campaign_id: null,
          contact: {
            id: null,
            first_name: null,
            last_name: null,
            phone_1: null,
            email_address: null,
          },
          property: {
            line_1: null,
            city: null,
            state: null,
            postcode: null,
            postcode_ext: null,
            county: null
          },
          user_ids: [],
          roles: {
            lead_manager_id: null,
            acquisitions_manager_id: null,
            dispositions_manager_id: null,
            rehab_manager_id: null,
            transaction_coordinator_id: null,
          }
        },
        defaultForm: {
          validate_duplicates: true,
          market_id: this.$store.getters.market.id,
          status_id: null, // this.$store.getters['pipeline/activeStatuses'][0].id,
          due_at: dates.getTomorrowISO(),
          next_contact_at: null,
          campaign_id: null,
          contact: {
            id: null,
            first_name: null,
            last_name: null,
            phone_1: null,
            email_address: null,
          },
          property: {
            line_1: null,
            city: null,
            state: null,
            postcode: null,
            postcode_ext: null,
            county: null
          },
          user_ids: [],
          roles: {
            lead_manager_id: null,
            acquisitions_manager_id: null,
            dispositions_manager_id: null,
            rehab_manager_id: null,
            transaction_coordinator_id: null,
          }
        },
      }
    },
    created() {
      // This allows you to pass in formData without an id in order to add data to the defaultForm for the the create
      this.form = (this.formData && this.formData.id) ? this.$utils.clone(this.formData) : this.$utils.clone({...this.defaultForm, ...this.formData});
      if (!this.authUser.can_access_all_leads) {
        if (this.form.user_ids.indexOf(this.authUser.id) === -1) {
          // Auth User is not selected so we make sure to select it
          this.form.user_ids.push(this.authUser.id);
        }
      }
    },
    computed: {
      authUser() {
        return this.$store.getters.authUser;
      },
      allCampaigns() {
        return [
          { id: null, label: 'None' },
          ...this.$store.getters.activeCampaigns
        ];
      },
      allStatuses() {
        return this.$store.getters['pipeline/statuses'];
      },
      activeUsers() {
        return this.$store.getters.activeUsers;
      },
      statusRequiresDueAt() {
        const status = this.allStatuses.find(s => s.id === this.form.status_id);

        if (! status) return false;

        return status.state === ENUMS.StatusStateEnum.Active.value && !status.acceptable_time;
      },
      statusRequiresNextContactAt() {
        const status = this.allStatuses.find(s => s.id === this.form.status_id);
        const contacting = ENUMS.StatusStateEnum.Contacting.value;
        const followUp = ENUMS.StatusStateEnum.FollowUp.value;

        if(status && (status.state === contacting || status.state === followUp)) {
          let currentDate = new Date();
          currentDate.setHours(currentDate.getHours() + 24);
          this.form.next_contact_at = currentDate;

          return true;
        }

        this.form.next_contact_at = null;
        return false;
      },
    },
    methods: {
      close() {
        this.$parent.close();
      },
      create() {
        if (this.statusRequiresDueAt) {
          this.form.due_at = new Date(this.form.due_at);
          this.form.due_at.toISOString();
        } else {
          this.form.due_at = null;
        }

        if (this.statusRequiresNextContactAt) {
          this.form.next_contact_at = new Date(this.form.next_contact_at);
          this.form.next_contact_at.toISOString();
        } else {
          this.form.next_contact_at = null;
        }

        return this.$api.records.create(this.form)
          .then(res => {
            this.$buefy.toast.open({
              message: 'Lead was created',
              type: 'is-success'
            });

            return res;
          })
          .catch((error) => {
            if (error.response.status === 422) {
              let errors = error.response.data.errors;
              const hasDuplicates = !!errors.duplicate_contacts || !!errors.duplicate_records;
              if(hasDuplicates) {
                let confirmDuplicate = appendModal(
                  DuplicateWarningModal,
                  this,
                  {
                    duplicateContacts: errors.duplicate_contacts,
                    duplicateLeads: errors.duplicate_records,
                    usersWithAccess: errors.users_who_have_access_to_duplicates
                  }
                );

                confirmDuplicate.$on('override', () => {
                  this.form.validate_duplicates = false;
                  this.$parent.$parent.save(); // This is calling the save method on the Crud Modal that this is used in.
                });

                confirmDuplicate.$on('attachContact', (contact) => {
                  Console.log('attachContact:', contact, this.formData);
                  this.form.validate_duplicates= false;
                  this.form.contact.id = contact.id;
                  this.$parent.$parent.save(); // This is calling the save method on the Crud Modal that this is used in.
                });

                confirmDuplicate.$on("openRecordModal", (recordId) => {
                  // calls ModalCrubForm close() method
                  this.$parent.$parent.close();
                  this.$nextTick(() => {
                    // navigates to view record modal
                    router.replace({query: {lead: recordId}});
                  })
                });
              }
            }

            if (error.response.status === 422) this.validationErrors = error.response.data.errors;

            throw error;
          });
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
